<script setup>
import { onMounted, ref } from 'vue'
import axios from 'axios'

const catalogue = ref([])

onMounted(() => {
  axios
    .get('/produits')
    .then(succes => {
      catalogue.value = succes.data
    }, error => {
      console.error('ERREUR', error.response?.data || error.message)
    })
})

function toCurrency(value) {
  if (typeof value !== 'number') {
    return value
  }
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  }).format(value)
}
</script>

<template>
  <main class="home container overflow-auto" aria-labelledby="titre-home">
    <h1 id="titre-home">Acheter ou recharger un titre de transport</h1>
    <div class="alert alert-warning informations-rentree" role="alert">
      <h2 class="h5 mb-2">
        ATTENTION : nouvelles modalités au 1er septembre 2026 pour les transports scolaires (collèges et lycées)
      </h2>

      <p class="mb-2">
        Transports gratuits, dans la limite d’un aller-retour par jour (domicile/établissement) valable uniquement aux horaires d’ouverture et de fermeture de l’établissement en période scolaire.
      </p>

      <p class="mb-0">
        Trajets en journée sur lignes urbaines et TSR payants avec un abonnement jeune mensuel ou annuel, trajets à l’unité ou par 10.
      </p>
    </div>
    <hr/>

    <section aria-labelledby="titre-catalogue">
      <h2 id="titre-catalogue" class="visually-hidden">Catalogue des titres disponibles</h2>

      <ul id="store" class="row list-unstyled">

        <li
          class="carte card col-md-5 col-12 m-4"
          v-for="produit in catalogue"
          :key="produit.id"
        >
          <article class="card-body">
            <h3 class="libelle card-title">{{ produit.libelle }}</h3>

            <p class="card-text">{{ produit.description }}</p>

            <div class="div_price row">
              <div class="col-5">
                <p class="price">
                  <span class="visually-hidden">Prix :</span>
                  {{ toCurrency(produit.tarif) }}
                </p>
              </div>

              <div class="col-7 div_btn">
                <router-link
                  :to="{ name: 'achat', params: { codeProduit: produit.codeProduit }}"
                  class="bouton_achat btn"
                  :aria-label="`Acheter ${produit.libelle} pour ${toCurrency(produit.tarif)}`"
                >
                  <span>Acheter</span>
                  <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </router-link>
              </div>
            </div>
          </article>
        </li>

        <li class="carte card col-md-5 col-12 m-4">
          <article class="card-body">
            <h3 class="libelle card-title">Rechargement d'un titre</h3>

            <p class="card-text">
              Rechargez en quelques clics vos Pass Colibri depuis votre ordinateur, votre tablette ou votre smartphone.
            </p>

            <div class="div_price row">
              <div class="col-5"></div>

              <div class="col-7 div_btn">
                <router-link
                  :to="{ name: 'rechargement' }"
                  class="bouton_achat btn"
                  aria-label="Accéder au rechargement de titre"
                >
                  <span>Recharger</span>
                  <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </router-link>
              </div>
            </div>
          </article>
        </li>

      </ul>
    </section>
  </main>
</template>

<style scoped lang="scss">
@import "@/assets/main";

.home {
  h1 {
    text-align: center;
  }

  .informations-rentree {
    max-width: 900px;
    margin: 0 auto 2rem;
    border-left: 5px solid #f0ad4e;

    h2 {
      font-weight: 700;
      margin-bottom: 0.75rem;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  hr {
    margin-bottom: 2rem;
  }

  #store {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .carte {
      box-shadow: 0 0 10px 0 lightgray;
      margin: 1rem;

      .libelle {
        font-family: $titlefont;
        font-weight: bold;
        font-size: 1.25rem;
      }

      .div_price {
        margin-top: 2rem;

        .price {
          font-family: $titlefont;
          font-weight: 900;
          color: $firstcolor;
          font-size: 25px;
        }

        .div_btn {
          text-align: end;

          .bouton_achat {
            @include boutons;
          }

          .bouton_achat:hover {
            @include boutons_hover;
          }

          .bouton_achat:focus-visible {
            outline: 3px solid #212529;
            outline-offset: 2px;
          }
        }
      }
    }
  }
}
</style>
